export default __webpack_public_path__ + "static/media/banner.1ec0a572.jpg";